<template>
	<report-page
		:start-date="true"
		:end-date="true"
		:start-name="'Start date from'"
		:end-name="'Start date till'"
		get-url="/bo/report/datascience/policies"
		title="Policies Data Export"
		export-filename="policy_data_export"
	/>
</template>

<script>

export default {
	name: 'DatasciencePolicyExport',

};
</script>
